import { ScrollArea } from "@/components/ui/scroll-area";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { DailyItemsChecklist } from "../-data/schema";
import { Checkbox } from "@/components/ui/checkbox";
import { useEffect, useState } from "react";
import { httpClient } from "@/httpClient";
import getPharmacyID from "@/utils/pharmacy_code";
import { DailyItem } from "@/gen/dailyitems/common_pb";
import { useRouter } from "@tanstack/react-router";
import { useMutation } from '@connectrpc/connect-query'
import { markDailyItem, unmarkDailyItem } from "@/gen/pharmacy-PharmacyService_connectquery";
import { Router } from "lucide-react";
import { MarkDailyItemRequest } from "@/gen/dailyitems/mark_daily_item_pb";
import { UnmarkDailyItemRequest } from "@/gen/dailyitems/unmark_daily_item_pb";

const API_URL = import.meta.env.VITE_API_URL as string

const ChecklistComponent = ({ item, refreshData }: { item: DailyItem; refreshData: () => Promise<void> }) => {
  const [checked, setChecked] = useState(item.isMarked);
  const [allowStateChange, setAllowStateChange] = useState(true);
  const router = useRouter();

  const markMutation = useMutation(markDailyItem, {
    onSuccess: () => {
      setAllowStateChange(true);
      router.invalidate();
    },
    onError: (error) => {
      console.error("Error marking daily item:", error);
      setAllowStateChange(true);
    },
  })
  const unmarkMutation = useMutation(unmarkDailyItem, {
    onSuccess: () => {
      setAllowStateChange(true);
      router.invalidate();
    },
    onError: (error) => {
      console.error("Error marking daily item:", error);
      setAllowStateChange(true);
    },
  })

  return (
    <div className="flex items-center space-x-4 px-4 py-2 border-b-[1px]">
      <Checkbox
        value={item.id.toString()}
        id={item.id.toString()}
        checked={checked}
        disabled={!allowStateChange}
        onCheckedChange={async (checked) => {
          if (checked) {
            setChecked(true);
            setAllowStateChange(false);
            const data = new MarkDailyItemRequest()
            data.id = item.id;
            markMutation.mutate(data)
          } else {
            setChecked(false);
            setAllowStateChange(false);
            const data = new UnmarkDailyItemRequest()
            data.checklistId = item.checklistId
            unmarkMutation.mutate(data)
          }
        }}
      />
      <div>
        <p className="text-sm text-gray-400">{item.itemType}</p>
        <p className="text-sm truncate font-semibold">{item.itemName}</p>
      </div>
    </div>
  );
};

const DailyChecklist = ({ data }: { data: DailyItem[] }) => {
    const [dataState, setDataState] = useState<DailyItem[]>([]);
    const router = useRouter()
    useEffect(() => {
        setDataState(data);
    }, [data])
    async function refreshData() {
        router.invalidate()
    }
  return (
    <div className="col-span-3 border rounded-lg">
      <div className="h-[300px]">
        <h2 className="text-2xl font-bold pt-4 px-4">Daily Checklist</h2>
        {data.length === 0 && (
          <div className="flex flex-col items-center justify-center h-full">
            <p className="text-gray-400 text-sm">No data available</p>
          </div>
        )}
        <ScrollArea className="h-full mt-4">
          <RadioGroup defaultValue="option-one">
            {dataState.map((item, index) => (
              <ChecklistComponent item={item} refreshData={refreshData} key={item.id}/>
            ))}
          </RadioGroup>
        </ScrollArea>
      </div>
    </div>
  );
};

export default DailyChecklist;
